import { LOCATION_CHANGE } from 'react-router-redux';
import { combineActions, handleActions } from 'redux-actions';
import { mapReducersFromConfigurations } from '../../helpers/reducer';
import businessActions from '../business/actions';
import { configurations, getDataConfigurations } from './configurations';

export const initialState = {
  currentUser: {},
  currentSubscription: {},
  currentUserIndustryRoles: [],
  currentUserIndustryId: undefined,
  currentUserIndustry: undefined,
  currentUserIndustryRolesIsFetching: false,
  currentUserAfsLicences: [],
  currentUserCpdCategorys: [],
  currentUserBookmarks: [],
  currentUserCpdCategorysIsFetching: false,
  cpdCategories: [],
  cpdCategoryProgress: undefined,
  isFetchingBookmark: false,
  isFetchingCpdCategory: false,
  isFetchingCpdCategoryProgress: false,
  isFetching: false,
  isUpdating: false,
  setTrainingPlanSuccess: undefined,
  qualifications: [],
  isFetchingQualifications: false,
  error: null
};

const reducer = handleActions({
  ...mapReducersFromConfigurations('user')(configurations),
  ...mapReducersFromConfigurations('getData')(getDataConfigurations),
  [combineActions(businessActions.business.api.updatePaymentDetails.request)]: (state, action) => ({
    ...state,
    isUpdating: true
  }),
  [combineActions(businessActions.business.api.updatePaymentDetails.success,
    businessActions.business.api.updatePaymentDetails.failed)]: (state, action) => ({
      ...state,
      isUpdating: false
    }),
  [combineActions(businessActions.business.api.updatePaymentDetails.success)]: (state, action) => ({
    ...state,
    error: null,
    currentSubscription: action.payload.subscription,
    isFetching: false
  }),
  [combineActions(businessActions.business.api.cancelSubscription.success,
    businessActions.business.api.getSubscription.failed)]: (state, action) => ({
      ...state,
      error: null,
      currentSubscription: {},
      isFetching: false
    }),
  [LOCATION_CHANGE]: (state, action) => ({
    ...state,
    error: null,
    setTrainingPlanSuccess: undefined,
    isFetching: false
  })
}, initialState);

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/user/reducers.js